import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'groupBy'})
export class GroupByPipe implements PipeTransform {
  
  /**
    * Devuelve un arreglo conteniendo objetos {key: groupField, values: Array<any>}
    */
  transform(value: Array<any>, field:string): Array<any> {
    if (!value)
      return null;

    const groupedObj = value.reduce((prev, cur) =>{
      if(!prev[cur[field]]) {
        prev[cur[field]] = [cur]
      } else{
        prev[cur[field]].push(cur);
      }
      return prev;
    }, {});

    return Object.keys(groupedObj).map(key => ({ key, value: groupedObj[key] }));
  }
}


// WEBPACK FOOTER //
// ./src/pipes/groupBy.pipe.ts